var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCompany = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 22h-2v-2h2v2ZM8.5 19h-2v-2h2v2ZM8.5 16h-2v-2h2v2ZM18.5 22h-5v-2h5v2ZM18.5 19h-5v-2h5v2ZM18.5 16h-5v-2h5v2ZM18.5 13h-5v-2h5v2ZM18.5 10h-5V8h5v2ZM25.5 22h-2v-2h2v2ZM25.5 19h-2v-2h2v2Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 4a2 2 0 0 1 2 2v7h5a2 2 0 0 1 2 2v13H3V12a2 2 0 0 1 2-2h5V6a2 2 0 0 1 2-2h8ZM5 26h5V12H5v14Zm7 0h8V6h-8v20Zm10 0h5V15h-5v11Z",
  fill: "currentColor"
})));

export default SvgCompany;